import styled from 'styled-components';
import { Row, Col } from '@pickit/pickit-grid-system';

export const LoadBarContainer = styled.div`
  border-radius: 4px;
  font-size: 12px;
  position: relative;
`;

export const ProgressBarContainer = styled(Row)`
  margin: 0 !important;
  position: absolute;
  top: 0;
`;

export const ProgressBar = styled(Col)<{
  progress: number;
  completed: boolean;
  color: 'primary' | 'secondary';
}>`
  align-items: center;
  background-color: ${({ theme, progress, color }) =>
    progress !== 0 ? theme.loadBar.progress[color] : theme.loadBar.uncompleted};

  border-radius: ${({ completed }) => (completed ? '4px' : '4px 0 0 4px')};
  color: white;
  display: flex;
  height: 24px;
  justify-content: end;
  padding-right: 8px;
  font-weight: bold;
`;

export const UncompletedBarContainer = styled(Row)`
  align-items: center;
  background-color: ${({ theme }) => theme.loadBar.uncompleted};
  border-radius: 4px;
  height: 24px;
  margin: 0 !important;
  padding-right: 8px;
  color: #4d4d4d;
  text-align: end;
  font-weight: bold;
`;

export const UncompletedBar = styled(Col)`
  display: flex;
  justify-content: flex-end;
  & > {
    width: 'fit-content';
  }
`;

export const TotalAmountContainer = styled.div<{ showTotalAmount: boolean }>`
  visibility: ${({ showTotalAmount }) => (showTotalAmount ? 'visible' : 'hidden')};
`;
